(function () {
  function initSlideshows() {
    document.querySelectorAll('.card-slideshow').forEach(function (slideshow) {
      const slides = Array.from(slideshow.querySelectorAll('.card-slideshow__slide'));
      if (slides.length < 2) return;

      const speed = parseInt(slideshow.dataset.speed || '2000', 10);
      let current = 0;
      let transitioning = false;

      function goTo(next) {
        if (transitioning || next === current) return;
        transitioning = true;

        const prev = slides[current];
        const nextSlide = slides[next];

        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        nextSlide.classList.add('is-active');

        current = next;

        setTimeout(function () {
          prev.classList.remove('is-leaving');
          transitioning = false;
        }, 600);
      }

      setInterval(function () {
        goTo((current + 1) % slides.length);
      }, speed);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
  } else {
    initSlideshows();
  }
})();
